VjsAdmin.CommonApp = (function () {
    const init = function () {
        new CommonAppController();
    };

    let CommonAppController = VjsUtility.Controller.extend({
        events: {
            'click .activation-button': 'toggleCommonAppActivation',
            'change #common_app_enabled': 'toggleCommonAppIntegration',
        },
        toggleCommonAppActivation(e) {
            e.currentTarget.disabled = true;
            $('#activation-button-loading').removeClass('d-none');
            // disable the integration toggle since we are now processing
            $('#common_app_enabled').bootstrapToggle('disable');

            const pageForm = document.querySelector('#common-app-form');
            const apiData = {
                platform_id: pageForm.dataset.platformId,
                license_id: pageForm.dataset.licenseId,
                district_id: pageForm.dataset.districtId,
            };
            const req = new VjsUtility.Request();
            req.post(Slim.Router.pathFor(`api.commonapp.${e.currentTarget.value}`, { ceeb_code: $('#ceeb-code').val() }), apiData)
                .done(() => {
                    e.currentTarget.innerHTML = 'Request processing...';
                    $('#activation-button-loading').addClass('d-none');
                    VjsUtility.Notification.success({
                        text: 'Common App is processing the request. This will take a few minutes. Please return to this page later.',
                        time: 8000,
                    });
                })
                .fail((res) => {
                    e.currentTarget.disabled = false;
                    $('#activation-button-loading').addClass('d-none');
                    console.log(res);
                    const text = res.responseJSON.data.resultSet.message;
                    VjsUtility.Notification.error({
                        text,
                        time: 3500,
                    });
                });
        },
        toggleCommonAppIntegration(e) {
            const pageForm = document.querySelector('#common-app-form');
            const apiData = {
                platform_id: pageForm.dataset.platformId,
                license_id: pageForm.dataset.licenseId,
                district_id: pageForm.dataset.districtId,
                update_fields: { common_app_enabled: e.currentTarget.checked },
            };

            $('#common_app_enabled').bootstrapToggle('disable');
            $('#common-app-enabled-loading').removeClass('d-none');
            const req = new VjsUtility.Request();
            req.post(Slim.Router.pathFor('api.commonapp.settings.edit', { license_id: pageForm.dataset.licenseId }), apiData)
                .done(() => {
                    $('#common_app_enabled').bootstrapToggle('enable');
                    $('#common-app-enabled-loading').addClass('d-none');
                    // activation requests can only be done if the integration is disabled
                    $('.activation-button').prop('disabled', e.currentTarget.checked);
                    $('#disable-ca-warning').toggleClass('d-none');
                    VjsUtility.Notification.success({
                        text: `The Common App integration has been ${
                            e.currentTarget.checked ? 'activated' : 'deactivated'
                        } for this license.`,
                        time: 3500,
                    });
                })
                .fail((res) => {
                    console.log(res);
                    $('#common-app-enabled-loading').addClass('d-none');
                    VjsUtility.Notification.error({
                        text: 'There was a problem processing the request. Please reload the page.',
                        time: 3500,
                    });
                });
        },
    });

    return {
        init,
    };
}());
